import { getDomainUrl } from 'core/utils';

export const oldManufacturerDetailsPath = (manufacturerId: number | string) =>
  `${getDomainUrl()}/manufacturers/details?manufacturer=${manufacturerId}`;
